import React, { useState } from "react";
import { Radio } from "antd";
import "./StatementForm.css";
import StatementFormDetails from "../StatementFormDetails/StatementFormDetails";
import StatementHistory from "../StatementHistory/StatementHistory";

interface StatementFormProps {
  mistakeReported: boolean;
  historyEntityType: "Invoice" | "SupplierStatement";
  onDirtyChange: (isDirty: boolean) => void;
  onSaved: () => void;
}

const StatementForm: React.FC<StatementFormProps> = ({
  mistakeReported,
  historyEntityType,
  onDirtyChange,
  onSaved,
}) => {
  const [activeTab, setActiveTab] = useState("details");

  return (
    <div className="statementForm">
      <div className="statementForm-switchContainer">
        <Radio.Group
          value={activeTab}
          className="statementForm-switch"
          buttonStyle="solid"
          onChange={(e) => setActiveTab(e.target.value)}
        >
          <Radio.Button value="details">Details</Radio.Button>
          <Radio.Button value="history">History</Radio.Button>
        </Radio.Group>
      </div>

      <div className="statementForm-content">
        <div hidden={activeTab !== "details"}>
          <StatementFormDetails
            mistakeReported={mistakeReported}
            onDirtyChange={onDirtyChange}
            onSaved={onSaved}
          />
        </div>
        {activeTab === "history" && <StatementHistory entityType={historyEntityType} />}
      </div>
    </div>
  );
};

export default StatementForm;
